<div class="auth">
  <div class="login-form">
    <h3>{{ 'auth.accessYourAccount' | translate }}</h3>
    <div class="desc">{{ 'auth.getOneTimeCodeDesc' | translate }}</div>
    @if (loginFormGroup) {
      <form [formGroup]="loginFormGroup">
        <div class="form-group">
          <dx-text-box valueChangeEvent="change keyup" formControlName="value"></dx-text-box>
          @if (displayRequiredError(loginFormGroup.get('value'))) {
            <div class="ng-invalid-comment">
              {{ 'validation.required' | translate }}
            </div>
          }
        </div>
        <div class="submit">
          <dx-button
            class="btn-xl btn-rounded"
            stylingMode="contained"
            type="default"
            text="{{ 'bookOnline.nextDate' | translate }}"
            (onClick)="onValueSubmit()">
          </dx-button>
        </div>
      </form>
    }
    @if (sysLoginProviders.length > 0) {
      <div class="acenter mt20 mb10">
        {{ 'general.or' | translate }}
      </div>
    }
    @if (sysLoginProviders.length > 0) {
      <div class="social-buttons grid-row grid-row-{{ sysLoginProviders.length }} pt10">
        @for (provider of sysLoginProviders; track provider; let i = $index) {
          <div>
            <!-- <a
            href="javascript:void(0)"
            (click)="socialLogin(provider)"
            class="simple-btn simple-btn-ricon">
            <i class="icon-social-{{ provider.name | lowercase }}">
              <img src="{{ provider.logoFileUri }}" />
            </i>
          </a> -->
          </div>
        }
      </div>
    }
  </div>
  @if (portalSetup?.allowNewClientRegisterOnline) {
    <div
      class="login-form form-footer form-footer-big grid-row grid-row-2 grid-gap-20 d-md-flex d-block acenter space-between-flex">
      <div>{{ 'bookOnline.newClient' | translate }}</div>
      <a
        href="javascript:void(0)"
        (click)="onSwitchToEmailConfirmation()"
        class="simple-lnk pt20-md d-inline-block"
        >{{ 'auth.createAccount' | translate }}</a
      >
    </div>
  }
</div>
